/** Blog destinations plan cap — English (structure pinned to fr). */
import type { BlogDestinationsKeys } from './fr';

const blogDestinationsEn: BlogDestinationsKeys = {
  usageTitle: 'Blog destinations on your plan',
  connectAtLimit:
    'You have reached your plan limit for blog destinations. Reconnecting an existing blog still works; to add a new one, upgrade or disconnect a blog.',
  errOverLimit: 'This blog is over your plan limit: it is read-only (disconnecting is still available).',
  overLimitTarget: 'Unavailable: over your plan limit',
};

export default blogDestinationsEn;
